export enum DateRangeOption {
    Week,
    LastWeek,
    Month,
    CustomDateRange,
}
